module.exports = __webpack_public_path__ + "images/FUSA_icons/054-cloud-computing.de3b3ab6000010e91f5ad3cb203646ee.svg";